var e={"core.view.loading":"Loading the Scandit SDK...","core.singleImageUploader.title":"Analyze an image from your device.","core.singleImageUploader.button":"Choose an Image","core.camera.recovery":"Tap/click to resume scanning"};

export { e as a };
